import React, { useRef } from "react";
import { Box, IconButton, Typography } from "@mui/material";
import { ArrowBackIos, ArrowForwardIos } from "@mui/icons-material";
import Slider from "react-slick"; // Install using `npm install react-slick slick-carousel`
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";

const Carousel2 = () => {
  const sliderRef = useRef(null);

  const images = [
    "https://i.postimg.cc/T2Q6tgRj/8d671fb15377e9eb29e4a65fb6aeb8ba.png",
    "https://i.postimg.cc/BZdpSS7W/Bode.png",
    "https://i.postimg.cc/sgPQKTn7/image.png",
    "https://i.postimg.cc/4xvPtbVF/image.png"
  ];

  const settings = {
    dots: false,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    arrows: false, // Custom arrows are used
    autoplay: true, // Enables automatic slide movement
    autoplaySpeed: 3000, // Set the time interval between each slide (3 seconds)
  };

  return (
    <div>
      <Box
        sx={{
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          marginBottom: "2rem", // Adds spacing below the centered content
        }}
      >
        <Typography
          variant="h4"
          sx={{
            color: "#6A983C",
            fontWeight: "bold",
            textAlign: { xs: "center", sm: "left" }, 
            fontFamily: '"Montserrat", sans-serif',
          }}
        >
          Serving the Future Today
        </Typography>
      </Box>

      <Box
        sx={{
          position: "relative",
          backgroundColor: "#F7F8F9",
          textAlign: "center",
          padding: "55px", // Remove padding to align image to the top
        }}
      >
        {/* Background Half Ellipse */}
        <Box
          sx={{
            position: "absolute",
            top: 0,
            left: "50%",
            transform: "translateX(-50%)",
            width: "100%",
            height: "230px",
            backgroundColor: "#E3EBD4",
            borderBottomLeftRadius: "75% 100px",
            borderBottomRightRadius: "75% 100px",
            zIndex: 0,
          }}
        ></Box>

        {/* Image Slider */}
        <Box
          sx={{
            position: "relative",
            maxWidth: "600px",
            margin: "0 auto",
            zIndex: 1,
            top: -55, // Align slider to top
          }}
        >
          <Slider {...settings} ref={sliderRef}>
            {images.map((src, index) => (
              <Box key={index} sx={{ position: "relative" }}>
                <img
                  src={src}
                  alt={`Slide ${index + 1}`}
                  style={{
                    width: "100%",
                    height: "350px",
                    borderBottomLeftRadius: "16px",
                    borderBottomRightRadius: "16px",
                    objectFit: "cover",
                    display: "block", // Ensures image alignment
                  }}
                />
              </Box>
            ))}
          </Slider>

          {/* Custom Arrow Buttons */}
          <IconButton
            sx={{
              position: "absolute",
              top: "10px", // Position close to the top
              right: "50px",
              backgroundColor: "rgba(106, 152, 60, 0.5)", // Transparent green
              color: "#fff",
              "&:hover": {
                backgroundColor: "rgba(106, 152, 60, 0.8)", // Darker green on hover
              },
              zIndex: 2,
            }}
            onClick={() => sliderRef.current.slickPrev()}
          >
            <ArrowBackIos />
          </IconButton>
          <IconButton
            sx={{
              position: "absolute",
              top: "10px", // Position close to the top
              right: "10px",
              backgroundColor: "rgba(106, 152, 60, 0.5)", // Transparent green
              color: "#fff",
              "&:hover": {
                backgroundColor: "rgba(106, 152, 60, 0.8)", // Darker green on hover
              },
              zIndex: 2,
            }}
            onClick={() => sliderRef.current.slickNext()}
          >
            <ArrowForwardIos />
          </IconButton>
        </Box>
      </Box>
    </div>
  );
};

export default Carousel2;
